// @flow
import type Locales from "../../i18n/Locales";
import type { ReduxState } from "../types";

/**
 * Retrieve the locale from state
 */
export const getLocale = (state: ReduxState): string => {
  return state.i18n?.locale ?? "en";
};

/**
 * Retrieve all available locales in the store
 */
export const getLocales = (state: ReduxState): Locales => state.i18n.locales;
